<template>
  <v-row justify="center">
    <v-btn outlined color="white" large @click="openDialog">
      {{ $t('widgets.subscribe.callout') }}
    </v-btn>
    <v-dialog v-model="dialog" scrollable max-width="650px" dark>
      <v-card>
        <v-card-title primary-title>
          {{ $t('widgets.subscribe.membershipLevels') }}
        </v-card-title>
        <v-card-text style="height: 600px;">
          <p>
            <!-- eslint-disable-next-line -->
            {{ $t('widgets.subscribe.subhead1') }}
          </p>
          <p>
            <!-- eslint-disable-next-line -->
            {{ $t('widgets.subscribe.subhead2') }} <a href="https://www.sagadash.com/terms-and-conditions">{{ $t('widgets.subscribe.termsCondit') }}</a>.
          </p>
          <div class="text-center">
            <v-btn outlined color="blue" large @click="checkout()">
              {{ $t('widgets.subscribe.getPro') }}
            </v-btn>
          </div>
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t('widgets.subscribe.featuresHead') }}
                </th>
                <th class="text-left">
                  {{ $t('widgets.subscribe.freeHead') }}
                </th>
                <th class="text-left">
                  {{ $t('widgets.subscribe.proHead') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="feature in features" :key="feature.name">
                <td>{{ feature.name }}</td>
                <td>{{ feature.free }}</td>
                <td>{{ feature.pro }}</td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t('widgets.subscribe.widgetHead') }}
                </th>
                <th class="text-left">
                  {{ $t('widgets.subscribe.freeHead') }}
                </th>
                <th class="text-left">
                  {{ $t('widgets.subscribe.proHead') }}
                </th>
              </tr>
            </thead>
            <tbody v-for="widget in widgets" :key="widget.name">
              <tr class="item-line">
                <td class="subtitle-2">{{ widget.name }}</td>
                <td v-if="widget.free === 'check'">
                  <v-icon color="green">mdi-check-circle</v-icon>
                </td>
                <td v-if="widget.free === 'uncheck'">
                  <v-icon color="red">mdi-close-circle</v-icon>
                </td>
                <td v-if="widget.pro === 'check'">
                  <v-icon color="green">mdi-check-circle</v-icon>
                </td>
                <td v-if="widget.pro === 'uncheck'">
                  <v-icon color="green">mdi-close-circle</v-icon>
                </td>
              </tr>
              <tr class="item-desc">
                <td colspan="3" class="caption">
                  {{ widget.description }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="text-center lowerBtn">
            <v-btn outlined color="blue" large @click="checkout()">
              {{ $t('widgets.subscribe.getPro') }}
            </v-btn>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="closeDialog">
            {{ $t('dialogs.changeWidget.dismissBtn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script src="https://js.stripe.com/v3"></script>
<script>
const stripe = Stripe('pk_test_Ex4ZqT4BRnOyJimuVax044sk00iVC52QuR')
export default {
  name: 'Subscribe',
  data() {
    return {
      dialog: false,
      features: [],
      widgets: []
    }
  },
  mounted() {
    const test = this.subscribe
  },
  methods: {
    openDialog() {
      this.generateFeatureText()
      this.generateWidgetText()
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    generateFeatureText() {
      console.log('Getting feature text')
      let featuresUpdate = [
        {
          name: this.$i18n.t('widgets.subscribe.ads'),
          free: this.$i18n.t('widgets.subscribe.yes'),
          pro: this.$i18n.t('widgets.subscribe.no')
        },
        {
          name: this.$i18n.t('widgets.subscribe.screens'),
          free: 3,
          pro: 10
        }
      ]
      console.log('Features are: ', featuresUpdate)
      this.features = featuresUpdate
    },
    generateWidgetText() {
      let widgetsUpdate = [
        {
          name: this.$i18n.t('widgets.clock.name'),
          free: 'check',
          pro: 'check',
          description: this.$i18n.t('widgets.clock.widgetSubText')
        },
        {
          name: this.$i18n.t('widgets.wifi.name'),
          free: 'uncheck',
          pro: 'check',
          description: this.$i18n.t('widgets.wifi.widgetSubText')
        },
        {
          name: this.$i18n.t('widgets.weather.name'),
          free: 'check',
          pro: 'check',
          description: this.$i18n.t('widgets.weather.widgetSubText')
        },
        {
          name: this.$i18n.t('widgets.peopleInSpace.name'),
          free: 'check',
          pro: 'check',
          description: this.$i18n.t('widgets.peopleInSpace.widgetSubText')
        }
      ]
      this.widgets = widgetsUpdate
    },
    checkout() {
      stripe.redirectToCheckout({
        clientReferenceId: this.$store.state.authentication.user.id,
        customerEmail: this.$store.state.authentication.user.email,
        items: [
          {
            // Define the product and plan in the Dashboard first, and use the plan
            // ID in your client-side code.
            plan: 'plan_H34q6lqzsv4OJh',
            quantity: 1
          }
        ],
        successUrl: 'https://www.example.com/success',
        cancelUrl: 'https://www.example.com/cancel'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.item-line {
  td {
    border-bottom: none !important;
  }
}
.item-desc {
  td {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }
}
.lowerBtn {
  margin-top: 10px;
}
</style>
